import { Text } from 'vvs-uikit'

const ExpBoost = ({ expMultiplier }: { expMultiplier: number }) => {
  const color = expMultiplier > 1 ? 'success' : expMultiplier < 1 ? 'failure' : 'black'

  return (
    <Text fontSize="13px" fontWeight="700" color={color}>
      {expMultiplier >= 1 ? '+' : ''}
      {((expMultiplier - 1) * 100).toFixed(0)}%
    </Text>
  )
}

export default ExpBoost
